import type { ChangeEvent, FC } from 'react';
import type { CoHostToggleProps } from '../../types';

const CoHostToggle: FC<CoHostToggleProps> = ({ enabled, disabled, onChange }) => {
  const handleToggle = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div className="personal-meetings-modal__cohost-toggle">
      <div className="personal-meetings-modal__option-label">Include co-hosts</div>
      <label className="personal-meetings-modal__toggle-switch">
        <input type="checkbox" checked={enabled} onChange={handleToggle} disabled={disabled} />
        <span className="personal-meetings-modal__toggle-slider" />
      </label>
    </div>
  );
};

export default CoHostToggle;
